import type { AccusationPhaseState } from "@cold-case/shared/accusation-phase";

/**
 * Keep the local player's committed vote/pick/warrant when a stale session poll
 * still shows pending/null/false before the server write is visible.
 */
export function mergeAccusationPhaseFromSync(
  incoming: AccusationPhaseState,
  local: AccusationPhaseState | null,
  selfUserId: string
): AccusationPhaseState {
  if (!local || local.stage !== incoming.stage || !selfUserId) return incoming;

  const votes = { ...incoming.votes };
  const myLocalVote = local.votes[selfUserId];
  const myIncomingVote = incoming.votes[selfUserId];
  if (
    (myLocalVote === "yes" || myLocalVote === "no") &&
    myIncomingVote === "pending"
  ) {
    votes[selfUserId] = myLocalVote;
  }

  if (incoming.stage !== "arrest") {
    return { ...incoming, votes };
  }

  const picks = { ...incoming.picks };
  const warrantLocked = { ...incoming.warrantLocked };
  const localPick = local.picks[selfUserId];
  if (localPick && !incoming.picks[selfUserId]) {
    picks[selfUserId] = localPick;
  }
  if (local.warrantLocked[selfUserId] && !incoming.warrantLocked[selfUserId]) {
    warrantLocked[selfUserId] = true;
  }

  return { ...incoming, votes, picks, warrantLocked };
}
